
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Gallery</h1>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img
			src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
	</div>
</section>
<section class="section section-sm gallery section-banner-bg-1">
	<div class="container">
		<div class="row justify-content-center row-cols-1 row-cols-lg-2 align-items-center">
			<div class="col">
				<div class="hovereffect hovereffect_div">
					<img class="img-responsive"
						src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/photogallery.jpg"
						alt="GHRSCF">
					<div class="overlay">
						<h2>Photo Gallery</h2>
						<div class="text-center position-relative">
							<a routerlink="/sport-events"
								class="cmn-button" ng-reflect-router-link="/photogallery"
								href="/photogallery">View More</a></div>
					</div>
				</div>

			</div>
			<div class="col">
				<div class="hovereffect hovereffect_div">
					<img class="img-responsive"
						src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/videogallery.jpg"
						alt="GHRSCF">
					<div class="overlay">
						<h2>Video Gallery</h2>
						<!-- <p class="cmn-button">
							<a routerLink="/videogallery">View More</a>
						</p> -->
						<div class="text-center position-relative">
							<a routerlink="/sport-events"
								class="cmn-button" ng-reflect-router-link="/videogallery"
								href="/videogallery">View More</a></div>
					</div>
				</div>

			</div>
		</div>
	</div>
</section>
